module.exports = __webpack_public_path__ + "img/pencil-blue.6245ced4.svg";